import posthog from 'posthog-js'

export default {
    install(Vue) {
        posthog.init(
            'phc_NBfwI6GsMkavJy7pKAmWTtd7ZHq5qXD9OiPXH4unSB6',
            {
                api_host: 'https://eu.i.posthog.com',
                capture_pageview: true,

                capture_heatmaps:true

            }
        )

        Vue.prototype.$posthog = posthog
    }
}